<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Summary Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /

      <b>Summary Report</b>
    </div>
    <!-- End of breadcrumbs -->
    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
        <div class="col-12 col-lg-6 col-sm-12">
          <button class="btn btn-primary" @click="print">Print</button>
        </div>

        <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
            <span class="m-auto"></span>
            <div class="btn-group" role="group">
            </div>
        </div>
        
    </div>

    <div class="row mb-3">
        <div class="col-12 col-lg-6 col-sm-12">
        </div>

        <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
            <span class="m-auto"></span>
            <div class="btn-group" role="group">
            </div>
        </div>
    </div>



    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- <p>Add new banner and company detail to be shown on Takaful Brunei Mobile App</p> -->

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            
            <div id="active" class>
                <div class="row mb-3">
                  <div class="col-12 col-lg-6 col-sm-12">
                  </div>

                  <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
                    <span class="m-auto"></span>
                    <!-- Year -->
                    <div class="col-6">
                        <div class="form-group">
                            <label>Year</label>
                            <select class="form-control" v-model="filter_year">
                                <option v-for="(year, index) in years" :key="index">{{year}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <button class="btn btn-primary" @click="applyFilter()">Filter</button> &nbsp;
                            <button id="btnAll" class="btn btn-primary d-none" @click="removeFilter()">All</button>
                        </div>
                    </div>
                  </div>
                </div>
                <div id="printGraph">
                  <h4 class="text-center"><b>Total Redeems For {{ year }}</b></h4>
                  <p class="text-center">
                    <b>
                        Products: $ {{ total_product }}
                        <br>
                        Charities: $ {{ total_charity }}
                      </b>
                  </p>

                  <GChart
                      type = "ColumnChart"
                      :data = "columnData"
                      :options = "columnOptions"
                  />
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


    <script>
// @ is an alias to /src
import axios from "axios";
import { GChart } from 'vue-google-charts'

export default {
  name: "vendor-redeem-list",
  components: { GChart },

  data() {
    return {
      lists: [],
      columnData:[],
      chart:[],
      total_product: 0,
      total_charity: 0,

      columnOptions:{
        title: "",
        height: 600,
        legend: 'bottom',
        vAxis: {title: "Total Price Redeemed ($)"},
        hAxis: {title: "Month"}
      },

      year: 0,
      years: [],
      filter_year: "",
    };
    
  },

  methods: {
    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    createDatatable() {
      $('#active_tbl').DataTable();
    },

    redirect(id){
      let vendor_id = this.$route.params.id;
      return "/vendor/product/details/" + vendor_id + "/" + id
    },

    activeClicked() {
      setTimeout(() => {
        this.createDatatable();
      }, 50)
    },

    loadGraph() {
      let token = localStorage.getItem('token')
      let id = this.$route.params.id;
      // check if has token
      if (token !== null) {
        token = JSON.parse(token)
        token = token.access_token
        
        axios.get(axios.lpsURL +'/point/redeem/summary/report' ,{
          headers: {
            'Authorization' : 'Bearer ' + token
          }
        })
        .then(res => {
          this.columnData = res.data.chart;
          this.total_product = res.data.total_product
          this.total_charity = res.data.total_charity
        })
      }
    },

    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper('printGraph');
    },

    loadYearFilter(){
      let date = new Date()
      let start_date = 2020
      let current_year = date.getFullYear()

      this.year = current_year;

      // Past 5 year
      for(let i = start_date; i < current_year + 1; i++){
        this.years.push(i)
      }
    },

    removeFilter(){
      $("#btnAll").addClass("d-none")

      this.filter_year = ""
      this.years = []
      
      this.loadYearFilter()

      this.loadGraph()
    },

    applyFilter(){
      $("#btnAll").removeClass("d-none")

      // Declare filters
      let year = ""

      if(this.filter_year.length != 0){
        year = "?filter_year=" + this.filter_year
        this.year = this.filter_year;
      }


      let token = localStorage.getItem('token')

      // check if has token
      if (token !== null) {
        token = JSON.parse(token)
        token = token.access_token
        
        axios.get(axios.lpsURL +'/point/redeem/summary/report' +year, {
          headers: {
            'Authorization' : 'Bearer ' + token
          }
        })
        .then(res => {
          this.columnData = res.data.chart;
          this.total_product = res.data.total_product
          this.total_charity = res.data.total_charity
        })
      }
    }
  },

  async created() {
    await this.loadGraph();
    this.loadYearFilter()
    this.createDatatable();
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white
}
</style>
